import React from "react";
import { Divider, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";

import { BOX_STATUS_OPTIONS } from "../../constants/boxing";
import { getDateData } from "../../helpers/dateHelper";
import {
  HubHookFormInput,
  HubHookFormSelect,
  HubIcon,
  UsersHookFormSelect,
} from "../../components";

import { statusRenderValue, StatusSelectRender } from "./StatusSelect";
import { StyledSideStack } from "./styles";

const ShipmentDetailsDialogBoxData = ({
  disabled,
  locationId = 1,
  createdAt,
  shipDate,
}) => {
  const getDate = (date) =>
    getDateData({ startDate: date, includeYear: true, includeTime: true });

  return (
    <StyledSideStack dark="true">
      <HubHookFormSelect
        name="status"
        label="Status"
        disabled={disabled}
        options={BOX_STATUS_OPTIONS}
        RenderComponent={StatusSelectRender}
        renderValue={(value) => statusRenderValue(value, BOX_STATUS_OPTIONS)}
        required
      />
      <UsersHookFormSelect
        name="userId"
        label="Employee Boxing"
        locationId={locationId}
        disabled={disabled}
        useDefault={false}
      />
      <HubHookFormInput
        name="weight"
        label="Final Weight"
        placeholder="Total Weight"
        disabled={disabled}
        endAdornment="lbs"
        isDecimal
        required
      />
      <HubHookFormInput
        name="notes"
        label="Notes"
        placeholder="Notes..."
        disabled={disabled}
        disableHelperText
        multiline
        rows={5}
      />
      <Divider orientation="horizontal" flexItem />
      <Stack gap="25px">
        <Stack gap="2px">
          <Stack direction="row" gap="5px" alignItems="center">
            <HubIcon icon="Calendar" size={10} />
            <Typography variant="boldCaptionL">Created Date:</Typography>
          </Stack>
          <Typography variant="caption">
            {getDate(createdAt || dayjs())}
          </Typography>
        </Stack>
        <Stack gap="2px">
          <Stack direction="row" gap="5px" alignItems="center">
            <HubIcon icon="Calendar" size={10} />
            <Typography variant="boldCaptionL">Ship Date:</Typography>
          </Stack>
          <Typography variant={shipDate ? "caption" : "captionGrey"}>
            {shipDate ? getDate(shipDate) : "Not Shipped"}
          </Typography>
        </Stack>
      </Stack>
    </StyledSideStack>
  );
};

export default ShipmentDetailsDialogBoxData;
